var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-image-advert flex-center"},_vm._l((_vm.imageList),function(item,i){return _c('img',{key:i,style:({
            'width': item.width,
            'height': item.height,
            'margin-left': item.margin
        }),attrs:{"src":item.img_url}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }